import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

import Cookies from "js-cookie";
import utf8 from "utf8";
import moment from "moment";
class DistributorFleetCountStore {
  vehicles = [];
  companydetails = [];
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicles: observable,
      companydetails: observable,
      total: observable,
      loading: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ userId, companyId, type }) {
    this.loading = true;

    var postData = {
      userId: userId,
      companyId: companyId,
      type: type,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=vehiclecounts", "postData=" + base64Input);

    console.log(response);
    // console.log("company Data", response?.data?.data?.companydata);
    this.vehicles = response?.data?.data;

    this.loading = false;
    return this.vehicles;
  }

  async getCreditData({ userId, companyId }) {
    var postData = {
      userId: userId,
      companyId: companyId,
    };
    // console.log(postData)

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=creditcounts", "postData=" + base64Input);

    return response?.data?.data;
  }

  async getDistributors({ companyId }) {
    var postData = {
      companyId: companyId,
    };
    // console.log(postData)

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=company&a=getDistributorCompanies",
        "postData=" + base64Input
      );

    this.companydetails = response?.data?.data?.companydetails;

    return response?.data?.data?.companydetails;
  }

  async getDistributorLoginData(companyId, userId) {
    const postData = {
      distCompanyId: companyId,
      userId: userId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    const response = await postApi
      .getClient()
      .post("index.php?c=user&a=distlogin", "postData=" + base64Input);
    console.log("Service response:", response?.data);
    return response?.data;
  }

  async loginWithCredentials(username, password) {
    const body = { userEmail: username, password: password };
    const postData = { tokenId: -1, user: body };
    const base64Input = await base64_encode(JSON.stringify(postData));

    const response = await postApi
      .getClient()
      .post(config.NodeUrl + "/auth/login", postData);

    return response?.data; // return full login response
  }
}

export default DistributorFleetCountStore;
